module.exports = __webpack_public_path__ + "static/media/iran.f380706b.svg";